import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../lib/constants";

const STATS = [
  { value: "55K+", label: "HCP Touchpoints Nationwide" },
  { value: "60K+", label: "Chemist Network Direct Relationships" },
  { value: "300+", label: "Market HQs Across India" },
  { value: "40–50%", label: "Average OPEX Reduction" },
];

export default function About() {
  return (
    <section id="about" className="py-20 md:py-32 bg-[#0B0F19] text-white relative overflow-hidden" data-testid="about-section">
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-teal-300 mb-3">
              About Medstry
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.02] mb-8">
              Specialized in <br />
              <span className="font-editorial italic font-medium text-slate-300">what others overlook.</span>
            </h2>
            <p className="text-slate-300 text-base md:text-lg leading-relaxed max-w-2xl mb-8">
              Medstry is a specialized healthcare sales and marketing services company focused on mature
              and tail-end brand revitalization through high-ROI solutions. We work where most field
              forces don't — extra-urban India.
            </p>
            <Link
              to="/about"
              data-testid="about-learn-more"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-white border-b border-white pb-1 hover:text-teal-300 hover:border-teal-300 transition-colors mb-12"
            >
              Meet the team & founders <ArrowRight className="h-4 w-4" />
            </Link>

            <div className="grid grid-cols-2 gap-x-8 gap-y-8 max-w-2xl">
              {STATS.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.06 }}
                  data-testid={`about-stat-${i}`}
                  className="border-t border-white/15 pt-4"
                >
                  <div className="font-display text-3xl md:text-4xl font-extrabold tnum">{s.value}</div>
                  <div className="text-sm text-slate-400 mt-1.5">{s.label}</div>
                </motion.div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="relative border-l-2 border-teal-300/40 pl-8 md:pl-10"
            >
              <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-teal-300 mb-5">
                From the Founder
              </div>
              <blockquote className="font-editorial italic text-2xl md:text-3xl leading-snug text-slate-100 mb-6">
                "Every mature and tail-end brand deserves dedicated attention and strategic investment.
                We make it economically viable through innovative talent deployment and
                performance-based economics."
              </blockquote>
              <div className="text-sm">
                <div className="text-slate-200 font-semibold">Inderjit Sood</div>
                <div className="text-slate-400">Co-Founder & Managing Director</div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
